import { translate, toggleLoader } from 'utils/common';
import { empty } from 'utils/validators';
import dataService from 'utils/dataservice'; 
import {SHOW_MESSAGE_TO_UI} from 'utils/constants';
  



export const TYPE_KEY = "bu";
export const VERSION_KEY = "version";
export const LANG_KEY = "language_code";
export const LANG_CODE_KEY = "language_code.code";
export const ID = "parent_o_id";
export const CMS_ID = "cms_id";

export const validationRules = [
    
]; 

export const queryFilters = {
    sap_product_id: {
        completionFields: ["completion_sap_product_id"],
        fields: [
            "display_name",
            "sap_product_id",
            "o_id"
        ],
        contextFilter: [
            { field: 'bu', value: '' },
            { field: 'workflowstate', value: '' },
            { field: 'market_code', value: '' }
        ]
    },
    display_name: {
        completionFields: ["completion_display_name"],
        fields: [
            "display_name",
            "sap_product_id",
            "o_id"
        ],
        contextFilter: [
            { field: 'bu', value: '' },
            { field: 'workflowstate', value: '' },
            { field: 'market_code', value: '' }
        ]
    },
    mat_no: {
        completionFields: ["completion_mat_no"],
        fields: [
            "display_name",
            "sap_product_id",
            "o_id",
            "mat_no"
        ],
        contextFilter: [
            { field: 'bu', value: '' },
            { field: 'workflowstate', value: '' },
            { field: 'market_code', value: '' }
        ]
    },
    ph2_id: {
        completionFields: ["completion_ph2_id"],
        fields: [
            "display_name",
            "sap_product_id",
            "o_id",
            "ph2_id"
        ],
        contextFilter: [
            { field: 'bu', value: '' },
            { field: 'workflowstate', value: '' },
            { field: 'market_code', value: '' }
        ]
    }
    // ,
    // barcode: {
    //     completionFields: ["completion_barcode"],
    //     fields: [
    //         "display_name",
    //         "sap_product_id",
    //         "o_id"
    //     ],
    //     contextFilter: [
    //         { field: 'bu', value: '' },
    //         { field: 'workflowstate', value: '' }
    //     ]
    // },
    // cms_id: {
    //     completionFields: ["completion_cms_id"],
    //     fields: [
    //         "display_name",
    //         "sap_product_id",
    //         "o_id"
    //     ],
    //     contextFilter: [
    //         { field: 'bu', value: '' },
    //         { field: 'workflowstate', value: '' }
    //     ]
    // }
}

export const MARKET_CODE="market_code"

export const MARKET_LANG = {
    "CTX":[
        {
           "value":"EN",
           "label":"English",
           "text":"English"
        }
     ], 
    "INT":[
        {
            "value":"EN",
            "label":"English",
            "text":"English"
         }], 
    "GLB":[
        {
            "value":"EN",
            "label":"English",
            "text":"English"
         }],
    "IDN": [
        {
            "value":"EN",
            "label":"English",
            "text":"English"
         },
         {
            "value":"ID",
            "label":"Indonesian",
            "text":"Indonesian"
         } ], 
    "LAO": [
        {
            "value":"EN",
            "label":"English",
            "text":"English"
         },
         {
            "value":"LO",
            "label":"Lao",
            "text":"Lao"
         }], 
    "MMR": [
        {
            "value":"EN",
            "label":"English",
            "text":"English"
         },
         {
            "value":"MY",
            "label":"Burmese",
            "text":"Burmese"
         } ], 
    "PHL": [
        {
            "value":"EN",
            "label":"English",
            "text":"English"
         },
         {
            "value":"FIL",
            "label":"Filipino",
            "text":"Filipino"
         } ], 
    "THA": [
        {
            "value":"EN",
            "label":"English",
            "text":"English"
         },
         {
            "value":"TH",
            "label":"Thai",
            "text":"Thai"
         }], 
    "VNM":[
        {
            "value":"EN",
            "label":"English",
            "text":"English"
         },
         {
            "value":"VI",
            "label":"Vietnamese",
            "text":"Vietnamese"
         } ],
    "KHM":[
        {
            "value":"EN",
            "label":"English",
            "text":"English"
         },
         {
            "value":"KM",
            "label":"Cambodian",
            "text":"Cambodian"
         } ],
}

